import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal, Form, Row, Col, Input , Button } from 'antd';
@inject('webEDIShipToStore')
@observer
class FormModal extends Component {
  state = {
  }
  formRef = React.createRef();
  componentDidMount() {
    const { title, record } = this.props
    if(title==='edit'){
      this.formRef.current.setFieldsValue({
        shipTo: record.shipTo,
        soldTo: record.soldTo,
        shipToGln: record.shipToGln,
        soldToGln: record.soldToGln,
      })
    }
  }
  handleOk=()=>{
    const {webEDIShipToStore, handleCancel, title, record } = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      if(title==='edit'){
          webEDIShipToStore.onEditShipToAction({...fieldsValue, id: record.id})
      }else {
          webEDIShipToStore.onAddShipTonAction(fieldsValue)
      }
      handleCancel()
    }).catch(err => {})

  }
  render() {
    const { addModalVisible, handleCancel,title } = this.props
    return (
      <>
        <Modal
          title={title==='edit'?"Edit":"Add"}
          closable={false}
          visible={addModalVisible}
          // onOk={this.handleOk}
          // onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type='primary' onClick={this.handleOk}>Save</Button>,
            <Button key="Cancel" onClick={handleCancel}>Cancel</Button>,
          ]}
        >
          <Form ref={this.formRef} key='addShipTo'>
            <Row justify='start' gutter={[10,10]}>
              <Col xs={24} sm={24} md={24} span={24} >
                <Form.Item name='shipTo' label="Ship To" labelCol={{span:8}} wrapperCol={{span:14}}
                           rules={[{ required: true, message: 'Only numbers can be entered！', pattern: new RegExp(/^[0-9]*$/) }]}>
                  <Input  maxLength={100} placeholder="Please enter ..." allowClear disabled={title==='edit'} style={{width:'100%'}} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24} >
                <Form.Item name='soldTo' label="Sold To" labelCol={{span:8}} wrapperCol={{span:14}}
                           rules={[{ required: true, message: 'Only numbers can be entered！', pattern: new RegExp(/^[0-9]*$/) }]}>
                  <Input  maxLength={100} placeholder="Please enter ..." allowClear style={{width:'100%'}} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24} >
                <Form.Item name='shipToGln' label="Ship To GLN" labelCol={{span:8}} wrapperCol={{span:14}}
                           rules={[{ required: true, message: 'Only numbers can be entered！', pattern: new RegExp(/^[0-9]*$/) }]}>
                  <Input  maxLength={100} placeholder="Please enter ..." allowClear style={{width:'100%'}} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24} >
                <Form.Item name='soldToGln' label="Sold To GLN" labelCol={{span:8}} wrapperCol={{span:14}}
                           rules={[{ required: true, message: 'Only numbers can be entered！', pattern: new RegExp(/^[0-9]*$/) }]}>
                  <Input  maxLength={100} placeholder="Please enter ..." allowClear style={{width:'100%'}} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    );
  }
}

export default FormModal;
